import React from "react"
import ContentLoader from "react-content-loader"

const ListingLoader = (props) => (
  <ContentLoader 
    speed={2}
    width={400}
    height={460}
    viewBox="0 0 400 460"
    backgroundColor="#dedede"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="174" y="25" rx="2" ry="2" width="167" height="35" /> 
    <rect x="11" y="21" rx="2" ry="2" width="152" height="152" /> 
    <rect x="175" y="74" rx="0" ry="0" width="166" height="36" /> 
    <rect x="174" y="122" rx="0" ry="0" width="167" height="44" /> 
    <rect x="14" y="193" rx="0" ry="0" width="325" height="182" />
  </ContentLoader>
)

export default ListingLoader


